import React from 'react';
import { createIcon } from 'components/shared/SVGIcon';

const ChevronUpIcon = createIcon(
  'ChevronUp',
  <path d="M10.990604,7.41879195 L4.41879195,13.990604 C3.86040268,14.5489933 3.86040268,15.4510067 4.41879195,16.009396 C4.97718121,16.5677852 5.87919463,16.5677852 6.43758389,16.009396 L12.0071588,10.4541387 L17.5624161,16.009396 C18.1208054,16.5677852 19.0228188,16.5677852 19.5812081,16.009396 C20.1395973,15.4510067 20.1395973,14.5489933 19.5812081,13.990604 L13.009396,7.41879195 C12.4653244,6.86040268 11.5489933,6.86040268 10.990604,7.41879195 Z" />
);

export default ChevronUpIcon;
